<template>
    <div class="weixin-refund-order fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">微信退款订单</span>
            <el-form inline ref="weixinRefundOrderForm" v-model="weixinRefundOrderData" class="right themed-form search-form" style="height: auto;line-height: 40px;">
                 <el-form-item>
					<el-date-picker style="width: 140px;" placeholder="下单起始日期" v-model="weixinRefundOrderData.startTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>
				<el-form-item>
					<span class="text-color">至</span>
				</el-form-item>
				<el-form-item>
					<el-date-picker style="width: 140px;" placeholder="下单结束日期" v-model="weixinRefundOrderData.endTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>

                <el-form-item label="所属代理商:">
                    <!-- <el-input v-model="weixinRefundOrderData.agentThreeName" placeholder="所属代理商"></el-input> -->
                <el-select v-model="weixinRefundOrderData.agentTreeIdNew"    filterable clearable>
					<el-option v-for="item in agentThreeLists" :key="item.index" :label="item.agentName" :value="item.agentId">
					</el-option>
				</el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="weixinRefundOrderData.wechatAgentName" placeholder="下单代理商"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="weixinRefundOrderData.mealName" placeholder="套餐"></el-input>
                </el-form-item>
                <!-- <el-form-item label="提现">
                    <search-select :optionsMetaAll="withdrawOperators" v-model="weixinRefundOrderData.withdraw"></search-select>
                </el-form-item>
                <el-form-item label="返点">
                    <search-select :optionsMetaAll="rebateOperators" v-model="weixinRefundOrderData.rebate2"></search-select>
                </el-form-item> -->
                <el-form-item>
                    <el-input v-model="weixinRefundOrderData.cardId" placeholder="卡号" class="iccid-width"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="weixinRefundOrderData.shortIccid" placeholder="短号" class="iccid-width"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="weixinRefundOrderData.orderNumber" placeholder="订单号" class="iccid-width"></el-input>
                </el-form-item>
                <el-form-item>
					<el-date-picker style="width: 140px;" placeholder="退款起始日期" v-model="weixinRefundOrderData.refundStartTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>
				<el-form-item>
					<span class="text-color">至</span>
				</el-form-item>
				<el-form-item>
					<el-date-picker style="width: 140px;" placeholder="退款结束日期" v-model="weixinRefundOrderData.refundEndTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>
                <el-form-item>
					<el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
				</el-form-item>

                <el-form-item>
					<el-button icon="el-icon-download" class="themed-button" type="info" @click="exportExcel">导出Excel</el-button>
				</el-form-item>
            </el-form>

            
        </div>
        <div class="content-box">
            <el-table
                ref='table'
                stripe
                border
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :max-height="maxTableHeight">
            
            <el-table-column
                prop="orderNumber"
                label="订单号"
                min-width="180"
                >
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="agentThreeName"
                    label="所属代理商"
                    min-width="100">
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="agentName"
                    label="所属总代理商"
                    min-width="120">
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="wechatAgentName"
                    label="下单代理商"
                    min-width="100">
            </el-table-column>
            <el-table-column
                    label="卡号"
                    min-width="180">
                    <template slot-scope="scope">
                        <el-link :underline='false' type="primary" >{{scope.row.cardId}}</el-link>
                    </template>
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="shortIccid"
                    label="短号"
                    min-width="120"/>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="phone"
                    label="接入号"
                    min-width="120">
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="mealName"
                    label="套餐名称"
                    min-width="170">
            </el-table-column>
            <el-table-column
                    label="充值状态"
                    min-width="98">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeStatus==1">待充值</span>
                        <span v-else-if="scope.row.rechargeStatus==2">已充值</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="推送状态"
                    min-width="98">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pushStatus==1">待推送</span>
                        <span v-else-if="scope.row.pushStatus==2">已推送</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="次月生效"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="(scope.row.effectType==2)&&(scope.row.mealType==10||scope.row.mealType==12)">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="mealTypeStr"
                    label="套餐类型"
                    min-width="150">
            </el-table-column>
            <el-table-column
                    :show-overflow-tooltip="true"
                    prop="mealSecondTypeStr"
                    label="二级套餐类型"
                    min-width="150">
            </el-table-column>
            <el-table-column
                    prop="orderMoney"
                    label="下单金额"
                    min-width="100">
            </el-table-column>
            <el-table-column
                    prop="orderMoney"
                    label="实际支付金额"
                    min-width="120">
            </el-table-column>
            <el-table-column
                    label="支付状态"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payStatus==1">已支付</span>
                        <span v-else-if="scope.row.payStatus==2">待支付</span>
                        <span v-else-if="scope.row.payStatus==3">已取消</span>
                        <span v-else-if="scope.row.payStatus==4">已退款</span>
                    </template>
            </el-table-column>
                <el-table-column
                    prop="orderCount"
                    label="数量"
                    min-width="50">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="accountName"
                    label="开卡公司"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="typeStr"
                    label="卡来源"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    label="充值类型"
                    min-width="98">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isFirstRecharge==1">首次充值</span>
                        <span v-else-if="scope.row.isFirstRecharge==2">续费充值</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="createTime"
                    label="下单时间"
                    min-width="180">
                </el-table-column>
                <el-table-column
                    prop="rebate2Money"
                    label="返现"
                    min-width="78">
                </el-table-column>
                <el-table-column
                    label="销售类型"
                    min-width="98">
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleType==1">线上</span>
                        <span v-else-if="scope.row.saleType==2">线下</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="合作类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.coType==1">普通类型</span>
                        <span v-else-if="scope.row.coType==2">按量结算</span>
                        <span v-else-if="scope.row.coType==3">api充值</span> -->
                         <span>{{_getCoType(scope.row.coType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="产品类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.productType==1">大河卡</span>
                        <span v-else-if="scope.row.productType==2">手表卡</span>
                        <span v-else-if="scope.row.productType==3">大流量卡</span> -->
                         <span>{{_getProductType(scope.row.productType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="业务类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.toType=='C'">ToC</span>
                        <span v-else-if="scope.row.toType=='B'">ToB</span>
                        <span v-else-if="scope.row.toType=='API'">API</span> -->
                         <span>{{_getToType(scope.row.toType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="netMoney"
                    label="最终支付金额"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    prop="orderExpireDate"
                    label="套餐到期时间"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    prop="saleName"
                    label="销售名称"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    prop="refundFee"
                    label="退款金额"
                    min-width="100">
                </el-table-column>
                <!-- <el-table-column
                    prop="refundReason"
                    label="退款理由"
                    min-width="150">
                </el-table-column> -->
                <!-- <el-table-column
                    label="卡来源"
                    min-width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">电信</span>
                        <span v-else-if="scope.row.type==2">其他卡务</span>
                        <span v-else-if="scope.row.type==3">移动</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column
                    prop="createTime"
                    label="下单时间"
                    min-width="180">
                </el-table-column> -->
                <el-table-column
                    show-overflow-tooltip
                    prop="refundTime"
                    label="退款时间"
                    min-width="180">
                </el-table-column>
                <!-- <el-table-column
                    prop="refundCreateUserName"
                    label="退款操作人"
                    min-width="120">
                </el-table-column> -->
                <el-table-column
                label="操作"
                min-width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" class="themed-button" type="primary" @click="handleShowDetail(scope.row.id)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="page"  :page-sizes="[5,10,15,50,100,1000]" :page-size="pageSize" style="text-align: left;margin-top: 20px;"
			 background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
        </div>

        <el-dialog
        title="订单详情"
        :visible.sync="dialogDetailVisible"
        :destroy-on-close='true'
        >
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">订单号</div></el-col>
        <el-col :span="12"><div>{{detailInfo.orderNumber}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">代理商名称</div></el-col>
        <el-col :span="12"><div>{{detailInfo.agentName}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">卡号</div></el-col>
        <el-col :span="12"><div>{{detailInfo.cardId}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">短号</div></el-col>
        <el-col :span="12"><div>{{detailInfo.shortIccid}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">套餐名称</div></el-col>
        <el-col :span="12"><div>{{detailInfo.mealName}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">套餐类型</div></el-col>
        <el-col :span="12">
            <!-- <div v-if="detailInfo.mealType==1">月卡叠加包</div>
            <div v-else-if="detailInfo.mealType==2">月卡续费</div>
            <div v-else-if="detailInfo.mealType==3">年卡叠加包</div>
            <div v-else-if="detailInfo.mealType==4">年卡续费</div> -->
            <div>{{_getMealType(detailInfo.mealType)}}</div>
        </el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">用户支付金额</div></el-col>
        <el-col :span="12"><div>{{detailInfo.orderMoney}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">支付状态</div></el-col>
        <el-col :span="12"><div v-if="detailInfo.payStatus==1">已支付</div>
            <div v-else-if="detailInfo.payStatus==2">待支付</div>
            <div v-else-if="detailInfo.payStatus==3">已取消</div>
            <div v-else-if="detailInfo.payStatus==4">已退款</div>
            <div v-else>退款中</div>
        </el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">数量</div></el-col>
        <el-col :span="12"><div>{{detailInfo.orderCount}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">开卡公司</div></el-col>
        <el-col :span="12"><div>{{detailInfo.accountName}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">卡来源</div></el-col>
        <el-col :span="12"><div v-if="detailInfo.type==1">电信</div>
            <div v-else-if="detailInfo.type==2">其他卡务</div>
        </el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">返现金额</div></el-col>
        <el-col :span="12"><div>{{detailInfo.money}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
        <el-col :span="12"><div class="dialog-row-label">下单时间</div></el-col>
        <el-col :span="12"><div>{{detailInfo.createTime}}</div></el-col>
        </el-row>
        <el-row :gutter="20" v-if="detailInfo.payStatus==4">
        <el-col :span="12"><div class="dialog-row-label">退款理由</div></el-col>
        <el-col :span="12"><div>{{detailInfo.refundReason}}</div></el-col>
        </el-row>
        <el-row :gutter="20" v-if="detailInfo.payStatus==4">
        <el-col :span="12"><div class="dialog-row-label">退款时间</div></el-col>
        <el-col :span="12"><div>{{detailInfo.refundTime}}</div></el-col>
        </el-row>
        <el-row :gutter="20" v-if="detailInfo.payStatus==4">
        <el-col :span="12"><div class="dialog-row-label">退款操作人</div></el-col>
        <el-col :span="12"><div>{{detailInfo.refundCreateUserName}}</div></el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" class="themed-button"  @click="dialogDetailVisible = false">关闭</el-button>
        </span>
        </el-dialog>

    </div>
</template>
<script>
import SearchSelect from '@/components/SearchSelect.vue'
import {agentListForUser } from '@/api/cardManagement/cardBill.js'
import {weChatRefundOrder,weChatOrderDetailInfo,exportWeixinRefundOrder} from '@/api/order.js'
import resize from '@/mixins/resize.js'
import dictGroup from '@/mixins/dictGroup.js'
export default {
    name:'weixinRefundOrder',
    components:{SearchSelect},
    mixins:[resize,dictGroup],
    data(){
        return{
            weixinRefundOrderData:{
                payStatus:'4',
                startTime:'',
                endTime:'',
                agentThreeName:'',
                agentTreeIdNew:"",
                wechatAgentName:'',
                mealName:'',
                withdraw:'',
                rebate2:'',
                cardId:'',
                orderNumber:'',
                refundStartTime:'',
                refundEndTime:'',
                shortIccid:"",
            },
            agentThreeLists:[],
            withdrawOperators:[
                {label:'全部',value:''},
                {label:'不可提现',value:'0'},
                {label:'可提现',value:'1'}
            ],
            rebateOperators:[
                {label:'全部',value:''},
                {label:'不可返点',value:'0'},
                {label:'可返点',value:'1'}
            ],
            tableData:[],
            page:1,
            pageSize:15,
            total:0,
            dialogDetailVisible:false,
            detailInfo:{
                orderNumber:'',
                agentName:'',
                cardId:'',
                mealName:'',
                mealType:'',
                orderMoney:'',
                payStatus:'',
                orderCount:'',
                accountName:'',
                type:'',
                money:'',
                createTime:'',
                refundReason:'',
                refundTime:'',
                refundCreateUserName:'',
                shortIccid:"",
            }
        }
    },
    created(){
         this.getAgentListForUser()
        this.getWeChatRefundOrderList()
    },
    methods:{
         getAgentListForUser(){
             agentListForUser().then(res=>{
                console.log(391)
                this.agentThreeLists = res
             })
            },
        getWeChatRefundOrderList(){
            let params = {
                pageSize:this.pageSize,
                pageNo:this.page
            }
            Object.assign(this.weixinRefundOrderData,params)
            weChatRefundOrder(this.weixinRefundOrderData).then(res=>{
                this.tableData = res.rows
                this.total= res.count
            })
        },
        onSearch(){
            this.page = 1
            this.getWeChatRefundOrderList()
        },
        exportExcel(){
            exportWeixinRefundOrder(this.weixinRefundOrderData).then(res=>{
					if (res.system_result_key == '0') {
						this.$alert('导出成功，请到导出记录中下载', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
							this.$router.push('/tob/i_export_list')
						});
					}else{
						this.$message({
						    showClose: true,
						    message: res.system_result_message_key,
						    type: 'error'
						});
					}
				})
        },
        onPageChange(page){
			this.page = page
			this.getWeChatRefundOrderList()
		},
		handleSizeChange(size){
			this.pageSize = size
			this.getWeChatRefundOrderList()
        },
        handleShowDetail(id){
            this.dialogDetailVisible = true
            let params ={
                id:id
            }
            weChatOrderDetailInfo(params).then(res=>{
                let result = res.entity
                this.detailInfo.orderNumber = result.orderNumber
                this.detailInfo.agentName = result.agentName
                this.detailInfo.cardId = result.cardId
                this.detailInfo.mealName = result.mealName
                this.detailInfo.mealType = result.mealType
                this.detailInfo.orderMoney = result.orderMoney
                this.detailInfo.payStatus = result.payStatus
                this.detailInfo.orderCount = result.orderCount
                this.detailInfo.accountName = result.accountName
                this.detailInfo.type = result.type
                this.detailInfo.money = result.money
                this.detailInfo.createTime = result.createTime
                this.detailInfo.refundReason = result.refundReason
                this.detailInfo.refundTime = result.refundTime
                this.detailInfo.refundCreateUserName = result.refundCreateUserName
                this.detailInfo.shortIccid = result.shortIccid
            })
        }
    }
}
</script>
<style>
    .weixin-refund-order .el-form-item__label{
        vertical-align: top;
    }
    .weixin-refund-order .dialog-row-label{
        text-align: right;
    }
</style>